import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Footer.module.css';
import AdSenseAd from '../../ads/AdSenseAd/AdSenseAd';
import MockAd from '../../ads/MockAd/MockAd';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Custom Link component with scroll to top
  const ScrollLink = ({ to, children }) => (
    <a 
      href={to}
      onClick={(e) => {
        e.preventDefault();
        handleNavigation(to);
      }}
    >
      {children}
    </a>
  );

  return (
    <footer className={styles.footer}>
      {/* Footer Ad - Only for free users */}
      {/* Real AdSense Ad - Uncomment when ready */}
      {/* <AdSenseAd
        adSlot={process.env.REACT_APP_ADSENSE_FOOTER_SLOT || "your-footer-ad-slot"}
        placement="footer"
        adFormat="horizontal"
      /> */}
      
      {/* Mock Ad for Testing - Remove when using real ads */}
      {/* <MockAd placement="footer" /> */}
      
      <div className={styles.footerContainer}>
        <div className={styles.footerGrid}>
          {/* Solutions Section */}
          <div className={styles.footerSection}>
            <h3>Solutions</h3>
            <Link to="/homeowner">Proposal Intelligence</Link>
            <Link to="/upload-quotes">Upload & Compare Quotes</Link>
            <Link to="/results-preview">AI Proposal Analysis</Link>
            <Link to="/homeowner/dashboard">Project Dashboard</Link>
            <Link to="/learn">Contractor Ratings</Link>
            <Link to="/my-projects">Project Documents</Link>
            <Link to="/start-project">Task Checklist Tracker</Link>
          </div>

          {/* Resources Section */}
          <div className={styles.footerSection}>
            <h3>Resources</h3>
            <Link to="/learn">Learning Center</Link>
            <Link to="/upgrade">Premium Features</Link>
            <Link to="/homeowner/knowledge-base">Knowledge Base</Link>
            <Link to="/homeowner/tutorials">Video Tutorials</Link>
            <Link to="/support">Help & Support</Link>
          </div>

          {/* Support Section */}
          <div className={styles.footerSection}>
            <h3>Support</h3>
            <Link to="/homeowner/knowledge-base">Knowledge Base</Link>
            <Link to="/homeowner/tutorials">Tutorials</Link>
            <Link to="/homeowner/support">Contact Support</Link>
            <Link to="/request-demo">Request Demo</Link>
          </div>

          {/* Company Section */}
          <div className={styles.footerSection}>
            <h3>Company</h3>
            <Link to="/about">About Us</Link>
            <Link to="/homeowner/pricing">Pricing</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/partners">Partner Program</Link>
            <Link to="/security">Security</Link>
            <Link to="/compliance">Compliance</Link>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.socialLinks}>
            <a href="https://linkedin.com/company/trakvu" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://twitter.com/trakvu" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://facebook.com/trakvu" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://youtube.com/trakvu" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
          
          <div className={styles.footerLegal}>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/security">Security</Link>
            <Link to="/gdpr">GDPR</Link>
            <Link to="/accessibility">Accessibility</Link>
          </div>
          
          <div className={styles.footerContact}>
            <div className={styles.contactItem}>
              <i className="fas fa-phone"></i>
              <span>+1 (610) 269-9220</span>
            </div>
            <div className={styles.contactItem}>
              <i className="fas fa-envelope"></i>
              <span>support@trakvu.com</span>
            </div>
            <div className={styles.contactItem}>
              <i className="fas fa-map-marker-alt"></i>
              <span>1405 Gallagherville Rd, Downingtown, PA 19335</span>
            </div>
          </div>
          
          <p className={styles.footerCopyright}>
            © {new Date().getFullYear()} Trakvu. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 